<template>
<div class="chapter">
<div class="inner_page">
<h1 title="Epigraph"></h1>
<p class="sectiontop">“What has been overlooked is the irrational, the inconsistent, the droll, even the insane, which nature, inexhaustibly operative, implants in an individual, seemingly for her own amusement.”</p>
<p class="att">Albert Einstein</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 02_Fm02.vue?7fda50d4